export function getView(width) {
  let newView = 'MobileView';
  if (width > 1220) {
    newView = 'DesktopView';
  } else if (width > 767) {
    newView = 'TabView';
  }
  return newView;
}
const actions = {
  COLLPSE_CHANGE: 'COLLPSE_CHANGE',
  COLLPSE_OPEN_DRAWER: 'COLLPSE_OPEN_DRAWER',
  CHANGE_OPEN_KEYS: 'CHANGE_OPEN_KEYS',
  TOGGLE_ALL: 'TOGGLE_ALL',
  CHANGE_CURRENT: 'CHANGE_CURRENT',
  UPDATE_HOME_BUTTON_VISIBILITY: 'UPDATE_HOME_BUTTON_VISIBILITY',
  CLEAR_MENU: 'CLEAR_MENU',
  UPDATE_SEARCH: 'UPDATE_SEARCH',
  UPDATE_SEARCH_BAR_VALUE: 'UPDATE_SEARCH_BAR_VALUE',
  BREADCRUMBS_ROUTES: 'BREADCRUMBS_ROUTES',
  toggleCollapsed: () => ({
    type: actions.COLLPSE_CHANGE,
  }),
  toggleAll: (width, height) => {
    const view = getView(width);
    const collapsed = view !== 'DesktopView';
    return {
      type: actions.TOGGLE_ALL,
      collapsed,
      view,
      height,
    };
  },
  toggleOpenDrawer: () => ({
    type: actions.COLLPSE_OPEN_DRAWER,
  }),
  changeOpenKeys: openKeys => ({
    type: actions.CHANGE_OPEN_KEYS,
    openKeys,
  }),
  changeCurrent: current => ({
    type: actions.CHANGE_CURRENT,
    current,
  }),
  updateHomeButtonVisibility: showHomeButton => ({
    type: actions.UPDATE_HOME_BUTTON_VISIBILITY,
    showHomeButton,
  }),
  clearMenu: () => ({ type: actions.CLEAR_MENU }),
  updateSearch: ({searchMode, searchPage, searchQuery}) => ({
    type: actions.UPDATE_SEARCH,
    searchMode,
    searchPage,
    searchQuery
  }),
  updateSearchBarValue: (searchBarValue) => ({
    type: actions.UPDATE_SEARCH_BAR_VALUE,
    searchBarValue: searchBarValue
  }),
  updateBreadCrumbs: (routes) =>({
    type: actions.BREADCRUMBS_ROUTES,
    routes_ :  routes
  })
};
export default actions;
